module.exports = __webpack_public_path__ + "img/xxhl2.ecb95975.png";